var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GoodList',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"goods":_vm.mallList}})
}
var staticRenderFns = []

export { render, staticRenderFns }